import 'leaflet/dist/leaflet.css';
import React from 'react';
import './index.css';
import App from './App';
import {createRoot} from "react-dom/client";
import {BrowserRouter} from 'react-router-dom';

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(<BrowserRouter><App /></BrowserRouter>);
} else {
    console.error('Root container missing in index.html');
}
